/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/require-default-prop */
 <template>
  <div>
    <b-form>
      <div class="row">
        <div class="col-md-2">
          <b-form-group id="input-group-9" label="Tipo" label-for>
            <v-select
              class="style-select"
              label="descricao"
              :options="tipos"
              :reduce="(tipo) => tipo.tipo"
              :dense="true"
              v-model="produtor.tipo"
            ></v-select>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group id="input-group-1" label="Nome" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="produtor.nome"
              type="text"
              placeholder="Informe o nome"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group id="input-group-2" label="CPF/CNPJ" label-for="input-2">
            <b-form-input
              id="input-2"
              v-model="produtor.cpf_cnpj"
              v-mask="['###.###.###-##', '##.###.###/####-##']"
              type="text"
              placeholder="Informe o CPF ou CNPJ"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group
            id="input-group-2"
            label="Inscrição Estadual"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              v-model="produtor.inscricao_estadual"
              type="text"
              placeholder="Informe a Inscrição Estadual"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-1">
          <b-form-group label="Cliente">
            <b-form-checkbox v-model="produtor.is_cliente" switch />
          </b-form-group>
        </div>
        <div class="col-md-1">
          <b-form-group label="Fonecedor">
            <b-form-checkbox v-model="produtor.is_fornecedor" switch />
          </b-form-group>
        </div>
        <div class="col-md-1">
          <b-form-group label="Transportador">
            <b-form-checkbox v-model="produtor.is_transportador" switch />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2">
          <b-form-group id="input-group-7" label="CEP" label-for="input-7">
            <b-form-input
              id="input-7"
              v-model="produtor.cep"
              v-mask="['#####-###']"
              type="text"
              placeholder="Informe o CEP"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group id="input-group-4" label="Endereço" label-for="input-4">
            <b-form-input
              id="input-4"
              v-model="produtor.endereco"
              type="text"
              placeholder="Informe o endereço"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group id="input-group-6" label="Número" label-for="input-6">
            <b-form-input
              id="input-6"
              v-model="produtor.numero"
              type="text"
              placeholder="Informe o número"
              required
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <b-form-group
            id="input-group-6"
            label="Complemento"
            label-for="input-12"
          >
            <b-form-input
              id="input-12"
              v-model="produtor.complemento"
              type="text"
              placeholder
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group id="input-group-5" label="Bairro" label-for="input-5">
            <b-form-input
              id="input-5"
              v-model="produtor.localidade"
              type="text"
              placeholder="Informe o bairro"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group id="input-group-3" label="Telefone" label-for="input-3">
            <b-form-input
              id="input-3"
              v-model="produtor.telefone"
              v-mask="['(##) ####-####', '(##) #####-####']"
              type="text"
              placeholder="Informe o telefone"
              required
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <b-form-group id="input-group-9" label="Estado" label-for>
            <v-select
              class="style-select"
              label="nome"
              :options="estados"
              :reduce="(estado) => estado.id_estado"
              :dense="true"
              v-model="produtor.id_estado"
            ></v-select>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group id="input-group-9" label="Cidade" label-for>
            <v-select
              class="style-select"
              label="nome"
              :options="cidades"
              :reduce="(cidade) => cidade.id_municipio"
              :dense="true"
              v-model="produtor.id_municipio"
            ></v-select>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <b-form-group
            id="input-group-9"
            label="Local aplicação"
            label-for="input-9"
          >
            <b-form-input
              id="input-9"
              v-model="produtor.local_aplicacao"
              type="text"
              placeholder="Informe o local de aplicação do defencivo"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-10"
            label="Unidade recebimento"
            label-for="input-10"
          >
            <b-form-input
              id="input-10"
              v-model="produtor.unid_recebimento"
              type="text"
              placeholder="Informe a unidade de recebimento da embalagem"
              required
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <b-button type="submit" variant="primary" @click.prevent="salvarProdutor"
        >Salvar</b-button
      >
    </b-form>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </div>
</template>
<script>
import produtorRural from '@src/services/produtor-rural'
import estado from '@/src/services/estado'
import { mask } from 'vue-the-mask'
import Loading from 'vue-loading-overlay'

export default {
  components: {
    Loading,
  },
  directives: { mask },
  props: {
    produtor: {},
  },
  data() {
    return {
      produtorEstado: '',
      produtorCidade: '',
      tipos: [
        {
          tipo: 'F',
          descricao: 'Física',
        },
        {
          tipo: 'J',
          descricao: ' Jurídica ',
        },
      ],
      estados: [],
      cidades: [],
      estadoSelecionado: {},
      cidadeSelecionada: {},
      modal: {
        show: false,
        mensagems: null,
        sucesso: null,
      },
      isLoading: false,
    }
  },
  watch: {
    'produtor.id_estado'() {
      this.listandoCidade(this.produtor.id_estado)
    },
    'produtor.id_municipio'() {
      this.produtor.id_municipio = this.produtor.id_municipio
    },
  },
  created() {},
  mounted() {
    this.listaEstado()
    this.listandoCidade(this.produtor.id_estado)
  },
  methods: {
    estadoId() {
      const token = this.$store.state.auth.currentUser.token
      estado.idEstado(token, this.produtor.id_estado).then((resposta) => {
        console.log(this.produtor.id_estado, resposta.data)
        this.produtorEstado = resposta.data.nome
        this.estadoSelecionado = this.produtorEstado
      })
    },
    loading(a) {
      a = !this.isLoading
      return a
    },
    modalShow() {
      if (this.modal.show === true) {
        this.modal.show = false
      }
    },
    listandoCidade(id) {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      estado.listaCidades(token, id).then((resposta) => {
        this.cidades = resposta.data.cidades
        this.isLoading = this.loading(this.isLoading)
      })
    },
    listaEstado() {
      const token = this.$store.state.auth.currentUser.token
      estado.lista(token).then((resposta) => {
        this.estados = resposta.data.estados
        console.log(resposta.data)
      })
    },
    selecionaMunicipio() {
      if (this.produtor.id_municipio != undefined) {
        const token = this.$store.state.auth.currentUser.token
        estado.municipio(token, this.produtor.id_municipio).then((resposta) => {
          this.produtorCidade = resposta.data.nome
          this.listandoCidade(this.produtor.id_estado)
          this.cidadeSelecionada = this.produtorCidade
        })
      } else {
        this.listandoCidade(this.produtor.id_estado)
      }
    },
    salvarProdutor() {
      const token = this.$store.state.auth.currentUser.token
      if (this.produtor.id_produtor_rural) {
        this.isLoading = this.loading(this.isLoading)
        produtorRural
          .update(token, this.produtor)
          .then((resposta) => {
            this.modal.show = true
            this.$bvToast.toast('Atualizado com sucesso', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.modal.mensagems = resposta.data.aviso
            this.isLoading = this.loading(this.isLoading)
          })
          .catch((erro) => {
            this.$bvToast.toast(erro.response.data.message.join(', '), {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = this.loading(false)
          })
      } else {
        this.isLoading = this.loading(this.isLoading)
        produtorRural
          .salvar(token, this.produtor)
          .then((resposta) => {
            this.isLoading = this.loading(this.isLoading)
            if (!resposta.data.sucesso) {
              this.$bvToast.toast(resposta.data.aviso.mensagem, {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            } else {
              this.$bvToast.toast('Salvo com sucesso!', {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })

              this.produtor = {}
            }
          })
          .catch((erro) => {
            this.isLoading = this.loading(this.isLoading)
            this.$bvToast.toast(erro.response.data.mensagem, {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          })
      }
    },
  },
}
</script>

<style>
</style>